module.exports = __webpack_public_path__ + "img/10_1_1_2.2831efcb.png";